const messages = {
  title: "Primljena pošta",
  desc: "Ovde ćete pronaći važna obaveštenja i vesti.",
  newMessages: "Nove poruke u primljenoj pošti",
  link: "Prikažite poruke",
  showMessages: "Prikažite poruke",
  message: {
    sender: "Pošiljalac",
    thread: "Predmet",
    date: "Datum",
  },
  sender: {
    system: "BRIDGESTONE PLUS",
    admin: "Admin",
  },
  back: "Nazad",
  time: {
    secondsAgo: "pre {time} sekundi",
    minutesAgo: "pre {time} minuta",
    hoursAgo: "pre {time} sati",
    daysAgo: "pre {time} dana",
  },
};
export default {
  messages,
};
